import React from 'react';

import { useTranslation } from 'react-i18next';

import {
  SwireAppEnum,
  SWIRE_LANGUAGE_ENUM,
  SWIRE_NOTIFICATION_EMAIL_PACIFIC,
  SWIRE_NOTIFICATION_EMAIL_TAIKOO,
  SWIRE_NOTIFICATION_URL_PACIFIC_EN,
  SWIRE_NOTIFICATION_URL_PACIFIC_ZH,
  SWIRE_NOTIFICATION_URL_TAIKOO_EN,
  SWIRE_NOTIFICATION_URL_TAIKOO_ZH,
} from 'constants-whitelabel';

import styles from './UserChannelSettingsV2.scss';

const SWIRE_INTRO_I18N =
  'web.pages.portal.settings.userChannelsettingsV2.swireNotificationIntro';

type Props = {
  appType: SwireAppEnum;
};

export function isTraditionalChinese(language: string): boolean {
  return (
    language === SWIRE_LANGUAGE_ENUM.ZH_HK ||
    language.startsWith(`${SWIRE_LANGUAGE_ENUM.ZH_HK}-`)
  );
}

function swireIntroKey(suffix: string): string {
  return `${SWIRE_INTRO_I18N}.${suffix}`;
}

function SwireLink({
  href,
  children,
}: {
  href: string;
  children: React.ReactNode;
}) {
  return (
    <a
      className={styles.swireNotificationLink}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  );
}

export function SwireNotificationSettingsIntro({ appType }: Props) {
  const { t, i18n } = useTranslation();
  const isTraditionalChineseLocale = isTraditionalChinese(i18n.language);
  const isTaikoo = appType === SwireAppEnum.TAIKOO_PLACE;

  if (!isTraditionalChineseLocale) {
    if (isTaikoo) {
      return (
        <div className={styles.swireNotificationIntro}>
          <p>
            {t(swireIntroKey('p1Prefix'))}
            <span className={styles.swireNotificationLink}>{SWIRE_NOTIFICATION_EMAIL_TAIKOO}</span>
            {t(swireIntroKey('p1Suffix'))}
          </p>
          <p>
            {t(swireIntroKey('p2Prefix'))}
            <SwireLink href={SWIRE_NOTIFICATION_URL_TAIKOO_EN}>
              {SWIRE_NOTIFICATION_URL_TAIKOO_EN}
            </SwireLink>
          </p>
        </div>
      );
    }

    return (
      <div className={styles.swireNotificationIntro}>
        <p>
          {t(swireIntroKey('p1Prefix'))}
          <span className={styles.swireNotificationLink}>{SWIRE_NOTIFICATION_EMAIL_PACIFIC}</span>
          {t(swireIntroKey('p1Suffix'))}
        </p>
        <p>
          {t(swireIntroKey('p2Prefix'))}
          <SwireLink href={SWIRE_NOTIFICATION_URL_PACIFIC_EN}>
            {SWIRE_NOTIFICATION_URL_PACIFIC_EN}
          </SwireLink>
        </p>
      </div>
    );
  }

  if (isTaikoo) {
    return (
      <div className={styles.swireNotificationIntro}>
        <p>
          {t(swireIntroKey('p1Prefix'))}
          <span className={styles.swireNotificationLink}>{SWIRE_NOTIFICATION_EMAIL_TAIKOO}</span>
          {t(swireIntroKey('p1Suffix'))}
        </p>
        <p>
          {t(swireIntroKey('taikooP2BeforeBreak'))}
          <br />
          <SwireLink href={SWIRE_NOTIFICATION_URL_TAIKOO_ZH}>
            {SWIRE_NOTIFICATION_URL_TAIKOO_ZH}
          </SwireLink>
        </p>
      </div>
    );
  }

  return (
    <div className={styles.swireNotificationIntro}>
      <p>
        {t(swireIntroKey('p1Prefix'))}
        <span className={styles.swireNotificationLink}>{SWIRE_NOTIFICATION_EMAIL_PACIFIC}</span>
        {t(swireIntroKey('p1Suffix'))}
      </p>
      <p>
        {t(swireIntroKey('pacificP2Prefix'))}
        <SwireLink href={SWIRE_NOTIFICATION_URL_PACIFIC_ZH}>
          {SWIRE_NOTIFICATION_URL_PACIFIC_ZH}
        </SwireLink>
      </p>
    </div>
  );
}
